/** *
 * html5 storage wrapper
 * Usage:
 * Set object to storage:       tcbase.storage.set(key, value, session)
 * Get object from storage:     tcbase.storage.set(key, value, session)
 * Params
 * key - string key to identify stored object. Internally it is prefixed with "tcbase_" to avoid collisions
 * value - object to be stored. Internally serialized from/to json string
 * session - If true session storage will be used (limited to one browser session). Default is false and it is stored forever.
 ***/

const parse = JSON.parse;
const keyPrefix = "tcbase_";
const getKey = function (key) {
  return keyPrefix + key;
};
const getStorage = function (session) {
  if (session) {
    return sessionStorage;
  }
  return localStorage;
};

export default {
  set(key, value, session) {
    const storage = getStorage(session);
    storage.setItem(getKey(key), JSON.stringify(value));
  },
  get(key, session) {
    const storage = getStorage(session);
    const value = storage.getItem(getKey(key));
    return parse(value);
  }
};
